export default __webpack_public_path__ + "static/expand-54667b3386e33f4c1c9255af8ebd91a8.webp";